import {DataSource} from "./DataSource";
import {ColId, ColSchema, Row} from "../../ui/components/Table";
import {BasicDataSourceDeps} from "../../platform/services/types/DataSourceDependencies";

export abstract class TableDataSource<T extends Record<string, any> = any, D extends Record<string, any> = T, DEPS extends BasicDataSourceDeps = BasicDataSourceDeps > extends DataSource<T, D, DEPS> {
    abstract getColsSchema(): ColSchema;

    abstract getColOrder(): ColId[];

    mapResultToTableRow(serverResponseItem: D, index: number): Row {
        return serverResponseItem as Row;
    }
}
